module.exports = __webpack_public_path__ + "img/information-circle.eb446451.svg";